import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "welcome-card-wrap mb-4" }
const _hoisted_2 = { class: "row justify-content-center g-4" }
const _hoisted_3 = { class: "card border-0 rounded-3 bg-white p-25" }
const _hoisted_4 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_5 = { class: "flex-grow-1" }
const _hoisted_6 = { class: "d-block" }
const _hoisted_7 = { class: "fs-24 mt-6 mb-11 lh-1" }
const _hoisted_8 = { class: "flex-shrink-0" }
const _hoisted_9 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stats, (stat, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "col-lg-3 col-sm-6",
          key: index
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(stat.title), 1),
                _createElementVNode("h3", _hoisted_7, _toDisplayString(stat.value), 1),
                _createElementVNode("div", null, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["d-inline-block border px-2 rounded-pill fs-12 fw-medium", {
                    'bg-success-80 border-success-60 text-success-60':
                      stat.trend > 0,
                    'bg-card-text-c border-danger-50 text-danger-50':
                      stat.trend <= 0,
                  }])
                  }, _toDisplayString(stat.trend > 0 ? "+" : "") + _toDisplayString(stat.trend) + "% ", 3)
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("img", {
                  src: _ctx.getImagePath(index),
                  alt: 'building' + (index + 1)
                }, null, 8, _hoisted_9)
              ])
            ])
          ])
        ]))
      }), 128))
    ])
  ]))
}